// src/context/LoadingContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

const LoadingContext = createContext(null);

// Permet d'y accéder depuis des fichiers “hors React” (ex: api.js)
let _ctxRef = null;
export const getLoadingContext = () => _ctxRef;

export function LoadingProvider({ children }) {
  const [pending, setPending] = useState(0);

  const start = () => setPending(p => p + 1);
  const stop  = () => setPending(p => Math.max(0, p - 1));
  const reset = () => setPending(0);

  const value = useMemo(() => ({
    pending,
    isLoading: pending > 0,
    start, stop, reset
  }), [pending]);

  _ctxRef = value; // expose la réf globale (utilisée par api.js)
  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
}

export const useLoading = () => useContext(LoadingContext);
